<template>
  <!-- 投诉单详情 -->
  <el-drawer title="投诉单详情" :visible.sync="show" direction="rtl" destroy-on-close style="padding: 20px;" size="70%" append-to-body>
    <div class="complaint-form-detail-container">
      <!-- 投诉信息 -->
      <div class="complaint-messages">
        <h2>投诉信息</h2>
        <el-descriptions v-for="(item, index) in messagesData" :key="item.id" :title="`${index + 1}、${item.title}`">
          <el-descriptions-item v-for="(it, idx) in item.messages" :key="idx" :label="it.label">
            {{ it.value }}
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 投诉进展 -->
      <div class="complaint-progress">
        <h2>投诉进展</h2>
        <div class="complaint-progress-item progress-item-status">
          <span >1、当前状态：{{ complaintDetail.complaint_state_text }}</span>
          <!-- v-if="['PENDING', 'PROCESSING'].includes(complaintDetail.complaint_state)"  所有状态都展示 -->
          <el-link  type="primary" :underline="false" style="margin-left: 10px;" @click="handleReplayUser">回复用户</el-link>
        </div>
        <div class="complaint-progress-item">
          <div style="margin-bottom: 10px;">2、协商历史</div>
          <BaseTable :data="historyList" border :columns="historyColumns"  max-height="300px" />
        </div>
      </div>
    </div>


    <!-- 回复用户 -->
    <ReplyUser ref="replyUser" @success="handleReplaySuccess" />
  </el-drawer>
</template>

<script>
import BaseTable from '@/components/common/BaseTable/index.vue';
// 回复用户
import ReplyUser from './replyUser.vue';
import { getWxMerchantComplaintDetailApi } from '@/api/merchant_complain_handle'
import { cloneDeep } from 'lodash'

export default {
  name: 'WxComplaintFormDetail',
  components: {
    BaseTable,
    ReplyUser
  },
  data () {
    return {
      show: false,
      messagesData: [
        {
          title: '投诉信息', id: 'complaint', messages: [
            { label: '投诉单号', field: 'complaint_id', value: '' },
            { label: '投诉时间', field: 'complaint_time', value: '' },
            { label: '投诉类型', field: 'problem_type_text', value: '' },
            { label: '问题描述', field: 'problem_description', value: '' },
          ]
        },
        {
          title: '订单信息', id: 'order', messages: [
            { label: '订单金额', field: 'amount', value: '', dependField: 'order', dependFieldType: 'array' },
            { label: '微信支付订单号', field: 'transaction_id', value: '', dependField: 'order', dependFieldType: 'array' },
            { label: '支付分服务单号', field: 'order_id', value: '-', dependField: 'service_order', dependFieldType: 'array' },
            { label: '申请退款金额', field: 'apply_refund_amount', value: '' }
          ]
        },
        {
          title: '投诉人信息', id: 'complaintUser', messages: [
            { label: '投诉人联系方式', field: 'payer_phone', value: '' },
            { label: '投诉人 openid', field: 'payer_openid', value: '' },
            { label: '用户投诉次数', field: 'user_complaint_times', value: '' },
            { label: '用户是否升级投诉', field: 'user_complaint_upgrade', value: '', transfer: true, type: 'boolean' }
          ]
        },
        {
          title: '商户信息', id: 'merchantInfo', messages: [
            { label: '被诉商户号', field: 'mch_id', value: '' },
            { label: '被诉商户名', field: 'mch_name', value: '' },
            { label: '商户订单号', field: 'out_trade_no', value: '', dependField: 'order', dependFieldType: 'array' },
          ]
        }
      ],
      complaintDetail: {},
      historyList: [],
      merchantData: {
        mch_id: '', // 商户号ID
        complaint_id: '' // 记录ID
      },
    }
  },
  computed: {
    historyColumns () {
      return [
        {
          label: '时间',
          key: 'operate_time',
        },
        {
          label: '角色',
          key: 'operator',
        },
        {
          label: '动作类型',
          key: 'operate_type',
        },
        {
          label: '内容',
          key: 'operate_details',
        },
        {
          label: '图片',
          key: 'work_image_url',
          width: 270,
          render: (h, params) => {
            const { work_image_url = [] } = params.row
            return (
              <div>
                {
                  work_image_url.map(it => {
                    return <el-image src={it} style="width: 50px; height: 50px;margin-right: 10px" fit="contain" preview-src-list={work_image_url}></el-image>
                  })
                }
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    triggleVisible (data) {
      this.merchantData = data
      getWxMerchantComplaintDetailApi(data).then(res => {
        const { data } = res.data
        this.complaintDetail = cloneDeep(data)
        this.messagesData = this.messagesData.map(item => {
          item.messages = item.messages.map(it => {
            if (it.dependField) {
              const dependData = this.complaintDetail[it.dependField]
              console.log('dependData', dependData)
              if (it.dependFieldType === 'array' && dependData.length) {
                it.value = dependData[0][it.field] || '-'
              }
            } else if (it.transfer) {
              if (it.type === 'boolean') {
                it.value = this.complaintDetail[it.field] ? '是' : '否'
              }
            } else {
              it.value = this.complaintDetail[it.field] || '-'
            }
            return it
          })
          return item
        })
        this.historyList = this.complaintDetail.history || []
        this.show = true
        // this.handleGetRecords()
      }).catch(() => {})
    },

    // 回复成功 重新获取一下协商历史
    handleReplaySuccess () {
      getWxMerchantComplaintDetailApi(this.merchantData).then(res => {
        const { data } = res.data
        this.complaintDetail = cloneDeep(data)
        this.historyList = this.complaintDetail.history || []
      }).catch(() => {})
    },

    handleReplayUser () {
      this.$refs.replyUser.triggleVisible(this.merchantData);
    }
  }
}

</script>

<style lang="scss" scoped>

.complaint-form-detail-container {
  padding: 20px;

  .el-descriptions {
    margin: 20px 0;
  }

  .complaint-progress {
    .progress-item-status {
      display: flex;
      align-items: center;
    }
    .complaint-progress-item {
      margin: 20px 0;
    }
  }
}
</style>
